import {Injectable} from '@angular/core';
import {ConfigService} from '../../services/config.service';
import {ApiService} from '../../services/api.service';
import {Drupal} from '../../../shared/cms/drupal/drupal';

@Injectable()
export class DrupalService extends Drupal {

    constructor(public config: ConfigService, public apiService: ApiService) {
        super(config,apiService);
    }

}
